import React, { useMemo } from "react";

import { css, cx } from "@emotion/css";

import { useStyles } from "@/hooks/useStyles.ts";
import { CardContent } from "@/uiKit/atoms/CardContent.tsx";

export type PrescriptionSignContentProps = {
  prescription: Blob;
  className?: string;
};

export const PrescriptionSignContent: React.FC<PrescriptionSignContentProps> = ({ prescription, className }) => {
  const styles = useStyles(makeStyles);
  const pdf = useMemo(() => {
    return URL.createObjectURL(new Blob([prescription], { type: "application/pdf" }));
  }, [prescription]);
  return (
    <CardContent className={cx(styles.container, className)}>
      <iframe id="prescription-sign-pdf" className={styles.iframe} src={pdf} />
    </CardContent>
  );
};

const IFRAME_MIN_HEIGHT_PX = 500;

const makeStyles = () => ({
  container: css({
    width: "100%",
    padding: 0,
  }),
  iframe: css({
    border: "none",
    width: "100%",
    minHeight: `${IFRAME_MIN_HEIGHT_PX}px`,
    margin: 0,
  }),
});
